import { z, zCalendarDate } from '@harvestiq/zod';

export const combinedLgmQuoteTemplateDataSchema = z.object({
  pdfs: z.array(
    z.object({
      filename: z.string(),
      fileUrl: z.string(),
    })
  ),
  userId: z.string().uuid(),
  campaignIds: z.array(z.string().uuid()),
  salesEffectiveDate: zCalendarDate(),
  personalCampaignMessage: z.string().optional(),
});
export type CombinedLgmQuoteTemplateData = z.infer<
  typeof combinedLgmQuoteTemplateDataSchema
>;
